export default __webpack_public_path__ + "static/media/pain-therapy.f6de9307.jpeg";